import * as angular from 'angular';

export const module = angular.module('loggingService', []);

export class LoggingService {
    private $window: angular.IWindowService;

    constructor($window: angular.IWindowService) {
        this.$window = $window;
    }

    log(...messages: Array<any>) {
        if (this.$window.console && this.$window.console.log) {
            /* tslint:disable-next-line */
            console.log(...messages);
        }
    }
}

module.factory('loggingService', function($window: angular.IWindowService) {
    'ngInject';

    return new LoggingService($window);
});
